import BasicRouterView from "../../components/BasicRouterView.vue";

const ctdRoutes = {
  path: "ctd",
  redirect: { name: "central-downloads-tabela" },
  meta: {
    label: "Central de Downloads",
    icon: "download",
    permissioOnly: false,
    show: true,
    tabsShow: false,
  },
  component: BasicRouterView,
  children: [
    {
      path: "central-de-dawnload/central-downloads-tabela",
      name: "central-downloads-tabela",
      meta: {
        label: "Lista de Downloads",
        icon: "settings",
        permissioOnly: false,
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/PaginaDownloads.vue"),
    },
  ],
};

export default ctdRoutes;
